export enum InteractionDialog {
  None = 'None',
  Repeat = 'Repeat',
  Transcript = 'Transcript',
}
